var _Text;
import React from 'react';
import { Box, Button, Text } from 'reaxl';
import clsx from 'clsx';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function ActiveDealIndicator(_ref) {
  let {
    orientation,
    onActiveDealDetailsClick,
    onCheckStatusClick
  } = _ref;
  return /*#__PURE__*/_jsx("div", {
    className: clsx({
      'padding-left-3': orientation === 'portrait'
    }, 'padding-vertical-3 padding-right-3'),
    children: /*#__PURE__*/_jsxs(Box, {
      borderColor: "brand-tertiary",
      backgroundColor: "brand-primary",
      "data-cmp": "listing-activeDealBadge",
      className: "text-center",
      children: [_Text || (_Text = /*#__PURE__*/_jsx(Text, {
        color: "primary",
        weight: "bold",
        size: 400,
        componentClass: "div",
        children: "You've submitted an offer."
      })), /*#__PURE__*/_jsxs("div", {
        className: "text-size-200 display-flex justify-content-center gap-2",
        children: [/*#__PURE__*/_jsx(Button, {
          bsStyle: "text",
          onClick: onCheckStatusClick,
          children: "Check Status"
        }), "|", /*#__PURE__*/_jsx(Button, {
          bsStyle: "text",
          onClick: onActiveDealDetailsClick,
          children: "See Vehicle Details"
        })]
      })]
    })
  });
}
export default ActiveDealIndicator;